// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"75ce4468","703":"1c9ca5b6"}[chunkId] + ".chunk.js";
};